export var FeeType;
(function (FeeType) {
    FeeType[FeeType["FEE_ADDED"] = 0] = "FEE_ADDED";
    FeeType[FeeType["FEE_INCLUDED"] = 1] = "FEE_INCLUDED";
    FeeType[FeeType["FEE_ADDED_AT_CHECKOUT"] = 2] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType || (FeeType = {}));
//# sourceMappingURL=FeeType.js.map